'use client';
import { usePathname } from 'next/navigation';
import LocalizedLinkClient from 'components/LocalizedLink/LocalizedLinkClient';
import { reverseTranslateSegments } from '../../i18n/translateHelpers';

export default function FerroFloatingButton() {
    const pathname = usePathname();

    // Route segments can be translated per locale (e.g. "activiteiten" -> "activities"/"activitaten"),
    // so reverse-translate to the canonical (Dutch) path before matching against it.
    const segments = pathname?.split('/').filter(Boolean) || [];
    const [localeSegment, ...restSegments] = segments;
    const lang = localeSegment?.split('-')[0] || 'nl';
    const canonicalPath = reverseTranslateSegments('/' + restSegments.join('/'), lang);

    if (canonicalPath.includes('/support-chat')) return null;
    if (canonicalPath.includes('/activiteiten')) return null;

    return (
        <LocalizedLinkClient
            href="/mijn-mkg/support-chat"
            title="Ferro AI"
            style={{
                position: 'fixed',
                bottom: '28px',
                right: '28px',
                zIndex: 9999,
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                overflow: 'hidden',
                boxShadow: '0 4px 18px rgba(0,81,136,0.22), 0 2px 6px rgba(0,0,0,0.12)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                textDecoration: 'none',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,81,136,0.3), 0 2px 8px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 18px rgba(0,81,136,0.22), 0 2px 6px rgba(0,0,0,0.12)';
            }}
        >
            <img
                src="/images/ferro-avatar.png"
                alt="Ferro AI"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
        </LocalizedLinkClient>
    );
}
